export const INSERT_PROJECT_MUTATION = `
  mutation InsertProject($input: ProjectInsertInput!) {
    insertProject(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_PROJECT_MUTATION = `
  mutation UpdateProject($filter: String!, $input: ProjectUpdateInput!) {
    updateProject(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_PROJECT_MUTATION = `
  mutation DeleteProject($filter: String!, $input: ProjectDeleteInput!) {
    deleteProject(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
